(function ($, window, _, eventhub, cssCreator) {
	'use strict';
	/**
	 *
	 * @param name {string} - string which contains card type
	 * @returns {string} - card type
	 */
	var getCardType = function (name) {
		if (name && _.isString(name)) {
			return name.substring(0, name.indexOf('_my_methods'));
		}
		return '';
	};
	var pluginName = 'PMSelectAccordion';
	var ghostClickElapsedTime = 30;
	var _lastEventTimestamp;
	var constants = {
		separatorClassName     : 'separator',
		hiddenGalleryClassName : 'hide_gallery',
		showGalleryClassName   : 'show_gallery',
		hasApplePayClassName   : 'withApplePay',
		onlyOnePmClassName     : 'lonely',
		groupOpenClassName     : 'g_open',
		groupActiveClassName   : 'g_active',
		applePmName            : 'ppp_ApplePay',
		fakeUpos               : {
			"ppp_ApplePay"  : 1,
			"ppp_GooglePay" : 1
		},
		supportedImageMimeType : {
			"image/gif"     : 1,
			"image/jpeg"    : 1,
			"image/png"     : 1,
			"image/svg+xml" : 1
		},
		resourceTypeUrl        : 'url'
	};

	var defaults = {
		enableGrouping     : false,
		allowActiveGroupClosing : true,
		isScrollEnabled	   : true,
		minVisiblePrimary  : 3,
		showControls       : false,
		staticControls	   : false,
		animationSpeed	   : 250,
		asteriskTemplate   : "*",
		verticalAdjustment : 13,
		wrapperHeightCorrection : 0,     // Fix Chrome table height bug
		itemContainerTagName : 'li',
		onClickSelector      : '.pm_container',
		pminfoPlaceholderSelector : '.pm_render',
		renderSeparately     : true,
		showUserPMs          : true,
		showMerchantPM       : true,
		prioritizePMs        : [],       // ["ppp_ApplePay", "ppp_GooglePay"],
		prioritizeFakeUpos   : false,
		showApplePayInline   : false,
		reduceApplePayPriority : true,
		activeElementClass   : 'selected',
		pminfoClass          : 'PMINFO',
		pms_label            : 'Payment Methods',
		pm_label             : 'Other Payment Methods',
		user_pm_label        : 'My Payment Methods',
		mainTemplate         : '<div class="pm-accordion-wrapper"></div>',
		ccCardTemplate	     : '',
		pm_order_prefix      : '', // when the plugin is used as a sub gallery
		regExCardPattern     : /\((\d{4})\)|\d\*{4}(\d{4})|\d\*{3}\s+\*{4}\s+\*{4}\s+(\d{4})/,	// matches (1234) and 3****1234 and 1*** **** **** 3567
		customCssObjCreator  : function(imgUrl, className){ return {background: "url('"+ imgUrl+ "') no-repeat center center;"}; },
		appleNavTemplates  : {
			main: '<div class="apple_pay_wrapp"><ul class="apple pm-list hidden"></ul></div>' ,
			itemPMTemplate: '<li data-value="<%-itemId %>" data-type="<%- type %>"><%=itemTemplate%></li>',
			orSeparator : '<li data-type="or"><p class="or_separator"><span>or</span></p></li>',
			otherBtn    : '<li data-type="btn"><div class="other"><div class="btn_container pm_available "><div class="pm-logo other_pms" ></div>' +
			'<div class="text pm-details"><%- t("other_pms")%></div></div></div></li>'
		},
		templates            : {
			wrapperPMTemplate: _.template('<div class="<%= data_type%> payment_header noselect"><span class="payment_header_label"><%= title%></span></div><div class="<%- data_type%> list-container"><div><ul class="<%- ulClass%>"></ul></div></div>'),
			itemPMTemplate   : _.template('<li data-value="<%-itemId %>" data-type="<%- type %>"><%=itemTemplate%></li>'),
			userPMTemplate   : _.template(
				'<div class="<%-classPrefix%> pm_container">' +
					'<div class="<%-classPrefix%> pm_side_status"></div>' +
					'<div class="<%-classPrefix%> pm_available " title="<%- ((details == \'&nbsp;\') ? \'\' : details) %>">' +
						'<div class="upm-logo <%-showClass%>"></div>' +
						'<div class="<%-classPrefix%> pm-details"><%=details%></div>' +
					'</div>' +
					'<span class="pm_selected"></span>'+
				'</div>' +
				'<div class="pm_render"></div>'
			),
			myPMTemplate     : _.template(
				'<div class="<%=classPrefix%> pm_container">' +
					'<div class="<%-classPrefix%> pm_side_status"></div>' +
					'<div class="<%=classPrefix%> pm_available" title="<%-label%>">' +
						'<div class="pm-logo <%-showClass%>"><% if (hasNoClass) { %><%-label%><%}%></div>' +
						'<div class="<%-classPrefix%> pm-details"><%=label%></div>' +
					'</div>' +
					'<span class="pm_selected"></span>'+
				'</div>' +
				'<div class="pm_render"></div>'
			)
		}
	};
/**
	var DATA_TYPE = {
		PMS : 'pms',
		UPM : 'user_pm',
		PM  : 'pm'
	};// options.renderSeparately
*/

	var handleClicks = function (mainElm, options, ctx) {
		var self 			 = ctx;
		var allowClickSamePM = options.allowClickSamePM;

		mainElm.on('click tap', options.onClickSelector, function (evt) {
			var currentTime = (new Date()).getTime();
			if (currentTime - _lastEventTimestamp < ghostClickElapsedTime) { //remove ghost click events
				_lastEventTimestamp = currentTime;
				return true;
			}
			var $liElm = $(evt.target).closest(options.itemContainerTagName);
			var uniqueId = $liElm.data('value');
			var isAlreadySelected = $(evt.target).closest(options.itemContainerTagName).hasClass(options.activeElementClass);
			if(self.Groups && self.Groups[uniqueId]){
				self.manageGroupedPMs(uniqueId, $liElm);
				_lastEventTimestamp = currentTime;
				return;
			}
			if (!isAlreadySelected || allowClickSamePM) {
				mainElm.find('.' + options.activeElementClass + ' ' + options.pminfoPlaceholderSelector).empty();
				mainElm.find('.' + options.activeElementClass + ' .pm_side_status').removeClass('arrow-div');
				mainElm.find('.' + options.activeElementClass).removeClass(options.activeElementClass);
				$(options.pminfoPlaceholderSelector, $liElm ).html($('<div class="' + options.pminfoClass + '"></div>'));
				$liElm.addClass(options.activeElementClass);
				var currData = null;
				if (isNaN(parseInt(uniqueId, 10))) {
					currData = self.options.pm_data[uniqueId];
				} else {
					currData = self.options.user_pm_data[_.findIndex(self.options.user_pm_data, {uniqueId : uniqueId})];
				}
				currData.pmPosition = self.order[uniqueId];
				eventhub.publish('select-pm', [currData, self, this]);
			} else {
				eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason:"already_selected"}, self, this]);
			}
			_lastEventTimestamp = currentTime;
			evt.preventDefault();
		});
	};

	function Plugin(element, options) {
		options = options || {};
		this.$element = $(element);
		if (!options.onClickSelector && options.itemContainerTagName) {
			options.onClickSelector = options.itemContainerTagName;
		}
		this.options = $.extend(true, {}, defaults, options);
		this.hasApplePay = false;
		this.count_upm = 0;
		this.count_pm = 0;
		this.init();
	}

	Plugin.prototype.init = function () {
		var self = this;
		cssCreator.setup(this.options.cssCreator);
		if(this.options.showMerchantPM) {
			eventhub.subscribe('pm-available', function (data) {
				this.updateData('pm', data);
			}, this);
		}
		if(this.options.showUserPMs) {
			eventhub.subscribe('user-pm-available', function (data) {
				this.updateData('user_pm', data);
			}, this);
		}
		eventhub.subscribe('dr-select-pm', function (data) {
			var uniqueId = (data.type && data.type === 'int') ? parseInt(data.uniqueId, 10) : data.uniqueId;
			this.handleDR(uniqueId, data.type, data.manual, data.allowApplePayAutoSelect);
		}, this);

		var applenav = _.template(this.options.appleNavTemplates.main)();

		this.$element.append( _.template(this.options.mainTemplate)());
		this.wrapper = this.$element.find('div');
		this.wrapper.append(applenav);
		this.$appleNav = this.wrapper.find('.apple.pm-list');
		handleClicks(this.wrapper, this.options, this);

		$(window).resize(_.bind(this.recalculateSize, this));
		self.wrapper.one('click tab', ".other", function (e) {
			_showOtherMethds(self);
		});

	};

	function _showOtherMethds(self){
		if(self.hasApplePay && self.wrapper.hasClass(constants.hiddenGalleryClassName)) {
			self.wrapper.removeClass(constants.hiddenGalleryClassName).addClass(constants.showGalleryClassName);
			$(window).trigger('resize');
		}
	}

	Plugin.prototype.manageGroupedPMs = function (groupId, $liGroupElm) {
		var self = this;
		if(groupId && self.Groups[groupId] && self.Groups[groupId].pm_list.length ){
			var $liElms = $(self.options.itemContainerTagName + '[data-group="' + groupId + '"]');
			if($liGroupElm && $liGroupElm.hasClass(constants.groupOpenClassName)){
				if(self.options.allowActiveGroupClosing || self.selected && self.selected.groupId !== groupId){
					$liGroupElm.removeClass(constants.groupOpenClassName);
					$liElms.addClass('hidden');
				}
			} else {
				$liGroupElm.addClass(constants.groupOpenClassName);
				$liElms.removeClass('hidden');
			}
			self.recalculateSize();
		}
	};

	Plugin.prototype.handleDR = function (uniqueId, idType, manual, allowApplePayAutoSelect) {
		var self = this;
		var $el, scroll_type, appleAutoSelect;
		if (self.hasApplePay && allowApplePayAutoSelect && (!(self.options.user_pm_data && self.options.user_pm_data.length) || !self.options.reduceApplePayPriority)) {
			$el = $(self.options.itemContainerTagName + '[data-value="ppp_ApplePay"][data-type="pm"]', self.wrapper);
			appleAutoSelect = true;
			scroll_type = 'scroll_pm';
		} else if(uniqueId === "auto_select" && idType === "auto_select"){
			$el = $(self.options.itemContainerTagName + '[data-value]', self.wrapper).first();
			scroll_type =  isNaN( parseInt($el.data('value'),10) ) ? 'scroll_user_pm' : 'scroll_pm';
		} else if(uniqueId === "auto_select" && idType === "pm"){
			$el = $(self.options.itemContainerTagName + '[data-value][data-type="pm"]', self.wrapper).first();
			scroll_type =  isNaN( parseInt($el.data('value'),10) ) ? 'scroll_user_pm' : 'scroll_pm';
		} else {
			$el = $(self.options.itemContainerTagName + '[data-value="' + uniqueId + '"]', self.wrapper);
			scroll_type = (idType === 'int') ? 'scroll_user_pm' : 'scroll_pm';
		}
		scroll_type = (!self.options.renderSeparately) ? 'scroll_pms' : scroll_type;
		if ($el.length) {
			var $targetElm = $(self.options.onClickSelector, $el);
			if ($targetElm.length === 0) { $targetElm =  $el; }
			$targetElm.trigger('click', manual);
			(self[scroll_type] && self[scroll_type].scrollToElement($el[0]));
			if(self.$appleNav && uniqueId != 'ppp_ApplePay' && !appleAutoSelect){
				_showOtherMethds(self);
			}
		} else {
			eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason:"incorrect_id"}, self, this]);
		}
	};

	Plugin.prototype.handleScrollbarVisibility = function () {
		var self = this;
		_.each(['user_pm', 'pm', 'pms'], function (data_type) {
			var current = self['$' + data_type];
			if (current) {
				var parent = current.parent();
				if (current.height() - parent.height() <= 0) {
					$('.iScrollLoneScrollbar', parent).hide();
					$('.iscroll-controls', parent.parent()).hide();
				}
				else {
					$('.iScrollLoneScrollbar', parent).show();
					$('.iscroll-controls', parent.parent()).show();
					self['scroll_' + data_type].refresh();
				}
			}
		})
	};
	/**
	 *
	 * @param data_type ( pm | user_pm | pms)
	 */
	Plugin.prototype.setupControls = function (data_type) {
		var self = this;
		var dtScroll = this['scroll_' + data_type];
		var parent = this['$' + data_type].parent().get(0);
		var wrapper = $(parent).parent();
		var controls = "<div class='iscroll-controls-vertical'><button type='button' class='up'>Up</button><button type='button' class='down'>Down</button></div>";

		$(wrapper).append(controls);

		if (dtScroll.scrollerHeight <= dtScroll.wrapperHeight) {
			$('.down', wrapper).attr("disabled", true);
		}
		$('.up', wrapper).attr("disabled", true);

		if (!$('.iScrollLoneScrollbar', wrapper).is(':visible')) {
			$('.iscroll-controls', wrapper).hide();
		}
		if (this.options.staticControls) {
			$(wrapper).addClass('iscroll-controls-static')
		}

		dtScroll.on('scrollEnd', function () {
			if (this.y == 0) {
				$('.up', wrapper).attr('disabled', true);
			}
			if (this.y < 0) {
				$('.up', wrapper).attr('disabled', false);
			}
			if (this.y == this.maxScrollY) {
				$('.down', wrapper).attr('disabled', true);
			}
			if (this.y > this.maxScrollY) {
				$('.down', wrapper).attr('disabled', false);
			}
		});

		$('.down', wrapper).on('click', function () {
			if ((dtScroll.y - $(parent).height()) <= dtScroll.maxScrollY) {
				dtScroll.scrollTo(0, dtScroll.maxScrollY, self.options.animationSpeed);
				$('.down', wrapper).attr('disabled', true);
			}
			else {
				dtScroll.scrollBy(0, -$(parent).height(), self.options.animationSpeed);
			}
			$('.up', wrapper).attr('disabled', false);
		});

		$('.up', wrapper).click(function () {
			if ((dtScroll.y + $(parent).height()) >= 0) {
				dtScroll.scrollTo(0, 0, self.options.animationSpeed);
				$('.up', wrapper).attr('disabled', true);
				$('.down', wrapper).attr('disabled', false);
			}
			else {
				dtScroll.scrollBy(0, $(parent).height(), self.options.animationSpeed);
				$('.down', wrapper).attr('disabled', false);
			}
		});
		this.recalculateSize();
	};

	Plugin.prototype.prioritizePms = function () {
		var self = this;
		var len = self.options.prioritizePMs && self.options.prioritizePMs.length || 0;
		for (var i = len - 1; i >= 0; i--) {
			if (self.options.prioritizeFakeUpos && self._fakeUpos && self._fakeUpos[self.options.prioritizePMs[i]]) {
				_changeDomElmPosition(self._fakeUpos[self.options.prioritizePMs[i]]);
			}
			_changeDomElmPosition(self.options.prioritizePMs[i]);
		}

		function _changeDomElmPosition(pmName) {
			var $elm = self.wrapper.find(self.options.itemContainerTagName + '[data-value="' + pmName + '"]');
			var parentElm = self.$pms || self.$user_pm;
			if ($elm.length && parentElm) {
				parentElm.prepend($elm);
			}
		}
	};

	Plugin.prototype.updatePmPosition = function () {
		var self = this;
		var order = {};
		var items = self.wrapper.find(self.options.itemContainerTagName + '[data-value]');

		_findOrder(items, self.options.pm_order_prefix);
		self.order = order;

		function _findOrder(items, prefix, subPrefix) {
			prefix = prefix ? prefix + "." : '';
			subPrefix = subPrefix ? subPrefix + "." : '';
			var count = 0;
			var giCount = 0;
			var upoCount = 0;
			var arr = items.toArray();
			_.each(arr, function (item, idx) {
				var $i = $(item);
				var id = $i.attr("data-value");
				var isUpo = $i.attr("data-type") === "user_pm";
				var groupItem = $i.attr("data-group");
				var pos, subPos;
				if(isUpo){
					pos = prefix + (++count);
					subPos = prefix + (++upoCount);
				}  else if (groupItem) {
					pos = prefix + order[groupItem].absolute + "." + (++giCount);
					subPos = order[groupItem].relative + "." + giCount;
				} else {
					pos = prefix + (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0' : ++count);
					subPos = (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0': subPrefix + (count - upoCount));
				}
				order[id] = {absolute: pos, relative: subPos};
			});
		}
	};

	Plugin.prototype.updateData = function (data_type, data) {
		data || (data = []);
		var self = this;
		var currentData = self[data_type] && self[data_type](data) || [];

		self.options[data_type + '_data'] = currentData;
		var type = (!self.options.renderSeparately) ? 'pms' : data_type;
		var ulSelector = '.' + type + '.pm-list';

		if (_.size(currentData) && !this.wrapper.find(ulSelector).length) {
			var stdPMHeader = self.wrapper.find('.pm.payment_header');
			var pmWrapperHtml = self.options.templates.wrapperPMTemplate({
				title     : self.options[ type + '_label'],
				ulClass   : type + ' pm-list',
				data_type : type
			});
			if (self.options.renderSeparately && data_type === 'user_pm' && stdPMHeader.length) {
				stdPMHeader.before(pmWrapperHtml);
			} else {
				self.wrapper.append(pmWrapperHtml);
			}

			self['$' + type] = self.wrapper.find(ulSelector);
		}
		var currentListElm = this['$' + type];
		if (currentListElm) {
			self.render(data_type);
			self.prioritizePms();
			self.updatePmPosition();

			var listWrapper = currentListElm.parent();
			listWrapper.height('300px');
			listWrapper.css('overflow', 'hidden');
			listWrapper.css('position', 'relative');
			_handleApplePayClasses(self, data_type);
		}
		$('.pm-logo.cc_card, .pm-logo.dc_card').html(this.options.ccCardTemplate);

		this.addScroll();
		this.recalculateSize();
		eventhub.publish('app.event.PMSelectAccordion.postRender', [{data_type: data_type}]);
		eventhub.publish('app.event.gallery.postRender', [{data_type: data_type, plugin: 'pmselectaccordion'}]);
	};

	function _handleApplePayClasses(self, data_type) {
		if (data_type !== "pm") {
			return;
		}
		if (self.hasApplePay && !self.options.showApplePayInline) {
			self.$element.addClass('withApplePay');
			self.$appleNav.removeClass('hidden');
		} else {
			self.$element.removeClass('withApplePay');
			self.$appleNav.addClass('hidden');
		}
	}

	Plugin.prototype.addScroll = function () {
		var self = this;
		var dataTypeArray = ( !this.options.renderSeparately ) ? ['pms'] : ['pm', 'user_pm'];
		_.each(dataTypeArray, function(data_type){
			if (!self['scroll_' + data_type] && self['$' + data_type]) {
				var newScrollObj = function () {
					this.isFake          = true;
					this.refresh         = _.identity;
					this.scrollToElement = _.identity;
					this.scrollTo        = _.identity;
					this.scrollBy        = _.identity;
					this.on              = _.identity;
				};

				if (self.options.isScrollEnabled ) {
					newScrollObj = IScroll;
				}
				self['scroll_' + data_type] = new newScrollObj(self['$' + data_type].parent()[0],
					{
						scrollY               : true,
						tap                   : true,
						scrollbars            : true,
						mouseWheel            : true,
						interactiveScrollbars : true,
						shrinkScrollbars      : 'scale',
						fadeScrollbars        : false,
						snap                  : false, //true
						scrollbarClass        : 'myScrollbar'
					});
				self['scroll_' + data_type].refresh();
				setTimeout(function () {
					if (self['scroll_' + data_type]) {
						self['scroll_' + data_type].refresh();
						if (self.options.showControls && $('.iscroll-controls', self['scroll_' + data_type]).length == 0) {
							self.setupControls(data_type);
							self.handleScrollbarVisibility();
						}
					}
				}, 100);
			}
		});
	};

	Plugin.prototype.render = function (data_type) {
		var self = this;
		var type = ( !self.options.renderSeparately ) ? 'pms' : data_type;
		var currentData = self.options[data_type + '_data'];
		var currentListElm = this['$' + type];
		var template = self.options.templates[(data_type === 'pm' ? 'myPMTemplate' : 'userPMTemplate')];
		if (_.isString(template)) {
			template = _.template(template);
		}
		var content = '';
		var applepay_item = false;

		function listItems(data, _data_type, isGroupMember) {
			_.each(data, function (item, idx) {
				switch (_data_type) {
					case 'user_pm':
						if (item.imgUrl) {
							var cssObj = self.options.customCssObjCreator(item.imgUrl, item.showClass);
							item.hasNoClass = !cssCreator.addCustomRule(item.showClass, cssObj);
						} else {
							item.hasNoClass = !cssCreator.makeRule(item.showClass);
						}
						item.classPrefix = 'upm';
						break;
					case 'pm':
						item.hasNoClass = item.isPmGroup ? false : !cssCreator.makeRule(item.name);
						item.classPrefix = 'pm';
						item.showClass = item.isPmGroup ? item.showClass : item.name;
						break;
				}
				if (_data_type === 'pm' && item.name === 'ppp_applepay' && !self.options.showApplePayInline) {
					applepay_item = item;
				} else {
					var $itemHTML = $(self.options.templates.itemPMTemplate({
						itemId       : item.uniqueId,
						itemTemplate : template(item),
						type         : _data_type
					}));

					if (item.groupId) {
						$itemHTML.attr('data-group', item.groupId).addClass('hidden');
					}
					if (item.isPmGroup) {
						$itemHTML.addClass('pm_group');
					}
					if (item.promotedPM) {
						$itemHTML.addClass("promotedPM");
					}
					if (item.additionalClass) {
						$itemHTML.addClass(item.additionalClass);
					}
					if (isGroupMember || !item.groupId) {
						content += $itemHTML[0].outerHTML;
					}
					if (item.isPmGroup && item.pm_list) {
						listItems(item.pm_list, _data_type, true);
					}
				}
			}, this);
		}

		if (currentListElm) {
			if (_.size(currentData) === 0) {
				currentListElm.parent().prev().show();
			} else {
				currentListElm.parent().prev().hide();
			}
			currentListElm.find(this.options.itemContainerTagName + '[data-type="' + data_type + '"]').remove();
			listItems(currentData, data_type);
			if (data_type === 'user_pm') {
				currentListElm.prepend(content);
			} else {
				self.$appleNav.find('[data-value="ppp_ApplePay"], [data-type="or"], [data-type="btn"]').remove();
				currentListElm.append(content);
				if (applepay_item && !self.options.showApplePayInline) {
					if (!self.wrapper.hasClass(constants.showGalleryClassName)) {
						self.wrapper.addClass(constants.hiddenGalleryClassName);
						var otherBtn = $(_.template(self.options.appleNavTemplates.otherBtn)());
						self.$appleNav.prepend(otherBtn);
					}

					var orSeparator = $(_.template(self.options.appleNavTemplates.orSeparator)());
					self.$appleNav.prepend(orSeparator);
					var appleElm = $(self.options.templates.itemPMTemplate({
						itemId       : applepay_item.uniqueId,
						itemTemplate : template(applepay_item),
						type         : data_type
					}));
					self.$appleNav.prepend(appleElm);
				}
			}
		}
		if ((self.count_upm + self.count_pm) === 1) {
			self.wrapper.addClass(constants.onlyOnePmClassName);
		} else {
			self.wrapper.removeClass(constants.onlyOnePmClassName);
		}
	};

	/**
	 * recalculate size of container relative to viewport height
	 */
	Plugin.prototype.recalculateSize = function () {
		var itemHeight        = 0;
		var items1            = 0;
		var items2            = 0;
		var headersHeight     = 0;
		var minVisiblePrimary = this.options.minVisiblePrimary;

		if (this.$user_pm && this.$user_pm.children().length) {
			var $upm_items = $(this.options.itemContainerTagName, this.$user_pm);
			itemHeight     = $upm_items.first().outerHeight(true);
			items1         = $upm_items.length;
			headersHeight += this.$user_pm.closest('.list-container').prev().outerHeight(true);
		}
		if (this.$pm && this.$pm.children().length) {
			var $pm_items  = $(this.options.itemContainerTagName, this.$pm);
			itemHeight     = $pm_items.first().outerHeight(true);
			items2         = $pm_items.length;
			headersHeight += this.$pm.closest('.list-container').prev().outerHeight(true);
		}
		if (this.$pms && this.$pms.children().length) {
			var $pms_items = $(this.options.itemContainerTagName, this.$pms);
			itemHeight     = $pms_items.first().outerHeight(true);
			items1         = $pms_items.length;
			headersHeight += this.$pms.closest('.list-container').prev().outerHeight(true);
		}
		var allItems = items1 + items2;
		var allItemsHeight = (allItems * itemHeight);

		allItemsHeight += headersHeight;
		var maxHeight = viewportSize.getHeight() - this.options.verticalAdjustment;
		if (this.options.showControls && this.options.staticControls) {
			var $controlsStatic = $(".iscroll-controls-static");
			var pTop = $controlsStatic.css('padding-top');
				pTop = parseInt(pTop) || 0;
			var pBottom = $controlsStatic.css('padding-bottom');
				pBottom = parseInt(pBottom) || 0;
			var count = $controlsStatic.length;
			maxHeight -= (pTop + pBottom) * count;
		}
		var maxPossible = Math.floor(( maxHeight - headersHeight) / itemHeight);

		if (allItemsHeight <= maxHeight) {
			if (this.$pms) {
				this.$pms.parent().height(allItems * itemHeight + this.options.wrapperHeightCorrection);
			} else {
				if (this.$user_pm) {
					this.$user_pm.parent().height(items1 * itemHeight + this.options.wrapperHeightCorrection);
				}
				if (this.$pm) {
					this.$pm.parent().height(items2 * itemHeight + this.options.wrapperHeightCorrection);
				}
			}
		} else if (!this.options.renderSeparately) {
			if (this.$pms) {
				this.$pms.parent().height(maxPossible * itemHeight);
			}
		} else {
			var item1v = Math.min(items1, Math.max(maxPossible - items2, minVisiblePrimary));
			var item2v = Math.min(items2, Math.max(maxPossible - item1v));
			if (this.$user_pm && this.$pm) {
				if (item1v <= minVisiblePrimary) {
					var primaryHeight = item1v * itemHeight;
					this.$user_pm.parent().height(primaryHeight);
					this.$pm.parent().height(maxHeight - primaryHeight - headersHeight);
				} else {
					var secondaryHeight = item2v * itemHeight;
					this.$user_pm.parent().height(maxHeight - secondaryHeight - (headersHeight ));
					this.$pm.parent().height(secondaryHeight);
				}
				this.handleScrollbarVisibility();
				return;
			}
			if (this.$user_pm) {
				this.$user_pm.parent().height(item1v * itemHeight);
			}
			if (this.$pm) {
				this.$pm.parent().height(item2v * itemHeight);
			}
		}
		this.handleScrollbarVisibility();
	};

	function _createGroup(item) {
		return {
			uniqueId    : item.groupId,
			label       : item.groupLabel,
			name        : item.groupLabel,
			showClass   : (item.groupShowClass || item.groupLabel).toLowerCase(),
			isPmGroup   : true,
			isIframe    : false,
			details     : '',
			classPrefix : 'pm',
			pm_list     : [],
			rawData     : {}
		}
	}

	Plugin.prototype.pm = function (merchantPMArray) {
		var self = this;
		var retObj = {};
		self.hasApplePay = false;
		self.Groups = {};
		self.count_pm = 0;
		_.each(_.map(merchantPMArray, function (item) {
			var iframe = null;
			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}
			var showClass = item.value || '';
			showClass = showClass.toLowerCase();
			var details   = "";
			var fee = item.attributes.customFees || {};
			if(showClass === 'ppp_applepay'){
				self.hasApplePay = true;
			}
			if (item.groupId && !self.Groups[item.groupId]) {
				self.Groups[item.groupId] = _createGroup(item);
			}
			self.count_pm++;
			return {
				uniqueId        : item.value,
				label           : item.label,
				name            : showClass,
				isIframe        : iframe,
				showClass       : showClass,
				details         : details || '',
				feeValue        : fee.feeValue ,
				feeValueType    : fee.feeValueType ,
				feeType         : fee.feeType ,
				promotedPM	    : item.attributes.promotedPM,
				additionalClass : item.attributes && item.attributes.additionalClass || '',
				rawData         : item  || {},
				classPrefix     : 'pm',
				groupId         : self.options.enableGrouping && item.groupId
			};
		}), function (elm) {
			if (self.options.enableGrouping && elm.groupId && self.Groups[elm.groupId]) {
				if (!retObj[elm.groupId]) {
					retObj[elm.groupId] = self.Groups[elm.groupId];
				}
				retObj[elm.groupId].pm_list.push(elm);
			}
			retObj[elm.uniqueId] = elm;
		});
		return retObj;
	};

	function _getUrl(metadata) {
		var url;
		if (metadata && metadata.imgContent && metadata.imgMimeType) {
			if (constants.supportedImageMimeType[metadata.imgMimeType]) {
				var normalizedString = (metadata.imgContent).replace(/(\r\n|\n|\r)/gm, "");
				url = ["data:", metadata.imgMimeType, ";base64,", normalizedString].join('');
			} else if (metadata.imgMimeType === constants.resourceTypeUrl) {
				url = metadata.imgContent.trim();
			}
		}
		return url;
	}

	Plugin.prototype.user_pm = function (userPMArray) {
		var self = this;
		var ccCardDetails = this.options.regExCardPattern;
		self.count_upm = 0;
		return _.map(userPMArray, function (item) {
			var iframe    = null;
			var showClass = null;
			var details   = "";
			var fee       = item.customFees || {};
			var issuer    = item.cardIssuer;
			var uniqueId  = parseInt(item.userPaymentOptionId, 10) || -1;
			var url       = _getUrl(item.metadata);

			if (item.attributes && _.has(item.attributes, 'isIframe')) {
				iframe = item.attributes.isIframe;
			}

			if (ccCardDetails.test(item.name)) {
				details = this.options.asteriskTemplate + (item.name.match(ccCardDetails)[1] || item.name.match(ccCardDetails)[2] || item.name.match(ccCardDetails)[3]);
				showClass = item.type || item.card_type || getCardType(item.className) || item.paymentOptionName;
				issuer = issuer || showClass;
				// Hack for WD
				if(item.paymentOptionName === "visa_checkout"){
					showClass = item.paymentOptionName;
				}
			} else {
				showClass = item.paymentOptionName || item.type || item.card_type || getCardType(item.className);
				details = item.name;
				issuer = issuer || item.displayPaymentOptionName;
			}

			showClass = showClass.toLowerCase() + (url ? '_' + uniqueId + '_modified' : '');
			self.count_upm++;
			return {
				uniqueId        : uniqueId,
				label           : item.displayPaymentOptionName || '',
				name            : item.paymentOptionName || '',
				isIframe        : iframe,
				showClass       : showClass,
				details         : details || '&nbsp;',
				feeValue        : fee.feeValue ,
				feeValueType    : fee.feeValueType ,
				feeType         : fee.feeType ,
				rawData         : item || {},
				issuer          : issuer,
				imgUrl          : url || '',
				classPrefix     : 'upm',
				netDeposit      : item.netDepositValue || '',
				additionalClass : item.additionalClass || ''
			};
		}, this);
	};

	/**
	 * Plugin initialization
	 * @param options
	 * @returns {*}
	 */
	$.fn[pluginName] = function (options) {
		return this.each(function () {
			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));
			}
		});
	};
})(jQuery, window, _, pubsub, cssCreator);